export default __webpack_public_path__ + "static/media/b3.4e9a6949.webp";